import { UserCog, LogOut } from 'lucide-react';
import { useSession } from '../api/session';
import { apiJson } from '../api/client';
import { useToast } from './ToastHost';

export function ImpersonationBanner(): React.ReactElement | null {
  const { data } = useSession();
  const { push } = useToast();

  if (!data?.user?.impersonatorId) return null;
  const adminName = data.impersonator?.username ?? 'admin';
  const targetName = data.user.username;

  async function stop(): Promise<void> {
    try {
      const res = await apiJson<{ success: boolean; returnUrl: string }>('impersonation/stop', {
        method: 'POST',
        body: '{}',
      });
      window.location.href = res.returnUrl || '/';
    } catch (err) {
      push({ message: (err as Error).message || 'Failed to end impersonation', severity: 'error' });
    }
  }

  return (
    <div
      role="status"
      style={{
        background: 'var(--sl-warning-bg, #b8860b)',
        color: 'var(--sl-warning-text, #fff8dc)',
        borderBottom: '2px solid var(--sl-warning, #daa520)',
        padding: '10px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        fontSize: 14,
        fontWeight: 500,
        position: 'sticky',
        top: 0,
        zIndex: 900,
      }}
    >
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
        <UserCog size={16} />
        Signed in as <strong>{targetName}</strong> (impersonated by <strong>{adminName}</strong>)
      </span>
      <button
        type="button"
        className="sl-btn sl-btn-sm"
        onClick={stop}
        style={{ background: '#fff', color: '#8b6914', borderColor: '#fff' }}
      >
        <LogOut size={14} /> Return to admin
      </button>
    </div>
  );
}
